// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiCreditGaugeController from "./ai_credit_gauge_controller"
application.register("ai-credit-gauge", AiCreditGaugeController)

import AdvertisementController from "./advertisement_controller"
application.register("advertisement", AdvertisementController)

import AuthModalController from "./auth_modal_controller"
application.register("auth-modal", AuthModalController)

import AdminCompanyRolesController from "./admin_company_roles_controller"
application.register("admin-company-roles", AdminCompanyRolesController)

import CompanyPhotoGalleryController from "./company_photo_gallery_controller"
application.register("company-photo-gallery", CompanyPhotoGalleryController)

import CompanyCardGalleryController from "./company_card_gallery_controller"
application.register("company-card-gallery", CompanyCardGalleryController)

import CompanySpatialCanvasController from "./company_spatial_canvas_controller"
application.register("company-spatial-canvas", CompanySpatialCanvasController)

import CompactHeaderController from "./compact_header_controller"
application.register("compact-header", CompactHeaderController)

import GoogleMapController from "./google_map_controller"
application.register("google-map", GoogleMapController)

import LazyMediaController from "./lazy_media_controller"
application.register("lazy-media", LazyMediaController)

import FavoritesController from "./favorites_controller"
application.register("favorites", FavoritesController)

import FlashNotificationController from "./flash_notification_controller"
application.register("flash-notification", FlashNotificationController)

import FeatureWorkspaceController from "./feature_workspace_controller"
application.register("feature-workspace", FeatureWorkspaceController)

import TourProjectController from "./tour_project_controller"
application.register("tour-project", TourProjectController)

import MyTourNoticeController from "./my_tour_notice_controller"
application.register("my-tour-notice", MyTourNoticeController)

import TourReorderController from "./tour_reorder_controller"
application.register("tour-reorder", TourReorderController)

import FlipbookController from "./flipbook_controller"
application.register("flipbook", FlipbookController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InspirationController from "./inspiration_controller"
application.register("inspiration", InspirationController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PostsMasonryController from "./posts_masonry_controller"
application.register("posts-masonry", PostsMasonryController)

import ShowcaseAnalyticsController from "./showcase_analytics_controller"
application.register("showcase-analytics", ShowcaseAnalyticsController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import SupportChatController from "./support_chat_controller"
application.register("support-chat", SupportChatController)

import AskAiController from "./ask_ai_controller"
application.register("ask-ai", AskAiController)

import CreditRefillController from "./credit_refill_controller"
application.register("credit-refill", CreditRefillController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CookieSettingsController from "./cookie_settings_controller"
application.register("cookie-settings", CookieSettingsController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import DelayedRevealController from "./delayed_reveal_controller"
application.register("delayed-reveal", DelayedRevealController)

import EventNavOverflowController from "./event_nav_overflow_controller"
application.register("event-nav-overflow", EventNavOverflowController)

import EventVideoPlaybackController from "./event_video_playback_controller"
application.register("event-video-playback", EventVideoPlaybackController)

import EntryRangeController from "./entry_range_controller"
application.register("entry-range", EntryRangeController)

import EntryComboboxController from "./entry_combobox_controller"
application.register("entry-combobox", EntryComboboxController)

import EntryFiltersController from "./entry_filters_controller"
application.register("entry-filters", EntryFiltersController)

import EntryLoaderController from "./entry_loader_controller"
application.register("entry-loader", EntryLoaderController)

import MenuController from "./bridge/menu_controller"
application.register("bridge--menu", MenuController)

import "./railsui"
